/**
 * Interface for laboratory partnership types.
 *
 * @property {number} id - The id.
 * @property {string} name - The name.
 * @property {slug} id - The slug.
 */
interface LaboratoryPartnershipType {
    id: number;
    name: string;
    slug: LaboratoryPartnershipTypeSlug | string;
}

export enum LaboratoryPartnershipTypeSlug {
    PRODUCT_AVAILABILITY = 'product-availability',
    BRANDING_SPACE = 'branding-space',
    ETHICAL_BRANDING_SPACE = 'ethical-branding-space'
}

export default LaboratoryPartnershipType;
